import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { useTurnAuthoritySnapshot, DEFAULT_TURN_AUTHORITY_SNAPSHOT } from './TurnAuthoritySnapshotContext'
import type { DrawerStackEntry } from '../hooks/useDrawerStackState'

interface Props {
  isAnyDrawerOpen: boolean
  topEntry: DrawerStackEntry | undefined
}

export function DrawerSnapshotRegistration({ isAnyDrawerOpen, topEntry }: Props) {
  const snapshotRef = useTurnAuthoritySnapshot()
  const owner = useRef(Symbol('surface contribution')).current

  useIsomorphicLayoutEffect(() => {
    snapshotRef.current.drawerOwner = owner
    snapshotRef.current.isAnyDrawerOpen = isAnyDrawerOpen
    snapshotRef.current.topEntry = topEntry
  }, [owner, snapshotRef, isAnyDrawerOpen, topEntry])

  // Lower risk than RightPanelSnapshotRegistration's unmount case -- DrawerContainer's desktop
  // and mobile mount points are mutually exclusive but always have exactly one active instance
  // whenever any Trip Chat surface is rendered, so a breakpoint flip always has a replacement
  // writer in the same commit. Reset on unmount anyway for consistency/defense-in-depth.
  useIsomorphicLayoutEffect(() => () => {
    if (snapshotRef.current.drawerOwner !== owner) return
    snapshotRef.current.drawerOwner = undefined
    snapshotRef.current.isAnyDrawerOpen = DEFAULT_TURN_AUTHORITY_SNAPSHOT.isAnyDrawerOpen
    snapshotRef.current.topEntry = DEFAULT_TURN_AUTHORITY_SNAPSHOT.topEntry
  }, [owner, snapshotRef])

  return null
}
